<template>
<v-card :flat="flat">
  <v-list two-line class="px-0 py-0">
    <v-list-tile avatar @click="e=>clickable && $emit('click',item,e)" :inactive="!clickable">
      <device-avatar :item="item" :eventlog="eventlog" :select="select"></device-avatar>
      <v-list-tile-content>
        <v-list-tile-title class="brown--text">{{ displayName }}</v-list-tile-title>
        <slot name="value" :device="item">
          <device-value :item="item" :eventlog="eventlog"></device-value>
        </slot>
      </v-list-tile-content>
      <slot :device="item"></slot>
    </v-list-tile>
  </v-list>
</v-card>
</template>

<script>
import DeviceAvatar from './DeviceAvatar'
import DeviceValue from './DeviceValue'

export default {
  name: 'DeviceItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    eventlog: {
      type: Object,
      required: true
    },
    clickable: {
      type: Boolean,
      default: false
    },
    select: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'device-avatar': DeviceAvatar,
    'device-value': DeviceValue
  },
  computed: {
    displayName() {
      return this.item.targetName || this.item.name;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceItem.vue